























import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import BtnSignInGoogle from '../../core/components/BtnSignInGoogle.vue';
import ModalCheckRecipients from './ModalCheckRecipients.vue';
import RecipientsPage from '../../settings/views/RecipientsPage.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { Combobox, LoadingDialog, MultipleSelect } from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment, { invalid } from 'moment';
import { Company, SuscriptionsList, Template, UsersEmails } from '../../../features/core/models/';
import { Recipient } from 'features/settings/models/Recipient';
import { ReportsServices } from '../api/ReportsServices';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        LoadingDialog,
        SimpleTable,
        SectionTitle,
        MultipleSelect,
        RecipientsPage,
        ModalCheckRecipients,
        BtnSignInGoogle
    }
})
export default class ModalAuthUser extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    modalTitle: string = 'Autenticarse con Google';

    mounted() {}
}
